import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import DoorsPage from "@/pages/DoorsPage";
import TrimworkPage from "@/pages/TrimworkPage";
import PanellingPage from "@/pages/PanellingPage";
import SandingPage from "@/pages/SandingPage";
import ProcessPage from "@/pages/ProcessPage";
import ContactPage from "@/pages/ContactPage";
import GalleryPage from "@/pages/GalleryPage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";
import MembersPage from "@/pages/MembersPage";
import ClientLoginPage from "@/pages/ClientLoginPage";
import ClientDashboardPage from "@/pages/ClientDashboardPage";
import StockportPage from "@/pages/locations/StockportPage";
import ManchesterPage from "@/pages/locations/ManchesterPage";
import CheadlePage from "@/pages/locations/CheadlePage";
import SalePage from "@/pages/locations/SalePage";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Toaster position="top-right" />
          <Routes>
            {/* Admin route without layout */}
            <Route path="/admin" element={<AdminPage />} />
            
            {/* Auth callback route */}
            <Route path="/auth/callback" element={<AuthCallback />} />
            
            {/* Public routes with layout */}
            <Route path="/*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/doors" element={<DoorsPage />} />
                  <Route path="/trimwork" element={<TrimworkPage />} />
                  <Route path="/panelling" element={<PanellingPage />} />
                  <Route path="/sanding" element={<SandingPage />} />
                  <Route path="/process" element={<ProcessPage />} />
                  <Route path="/gallery" element={<GalleryPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/my-enquiries" element={<MembersPage />} />
                  <Route path="/my-quotes/login" element={<ClientLoginPage />} />
                  <Route path="/my-quotes" element={<ClientDashboardPage />} />
                  {/* Location Pages */}
                  <Route path="/stockport" element={<StockportPage />} />
                  <Route path="/manchester" element={<ManchesterPage />} />
                  <Route path="/cheadle" element={<CheadlePage />} />
                  <Route path="/sale" element={<SalePage />} />
                  {/* Redirect old routes */}
                  <Route path="/carpentry" element={<DoorsPage />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
